import { ACTIVITY_DETAILS_COLORS, ACTIVITY_DETAILS_TYPOGRAPHY } from './constants';

interface SectionHeaderProps {
  title: string;
  color?: string;
}

/**
 * SectionHeader Component
 * 
 * Section header (e.g., "Try this", "How to make play last longer").
 * Responsive: Text scales 20px → 22px → 24px.
 */
export default function SectionHeader({ 
  title, 
  color = ACTIVITY_DETAILS_COLORS.sectionHeader 
}: SectionHeaderProps) {
  return (
    <h2
      className={`${ACTIVITY_DETAILS_TYPOGRAPHY.sectionHeader.weight} ${ACTIVITY_DETAILS_TYPOGRAPHY.sectionHeader.sizeClasses} ${ACTIVITY_DETAILS_TYPOGRAPHY.sectionHeader.tracking} px-6 sm:px-8 md:px-10 lg:px-12`}
      style={{
        fontFamily: 'DM Sans, sans-serif',
        color,
        margin: 0,
        lineHeight: 1,
      }}
    >
      {title}
    </h2>
  );
}
